export default [
	{name: 'admin', label: 'Admin'},
	{name: 'teacher', label: 'Teacher'},
	{name: 'student', label: 'Student'}
];